import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { ThemeProvider } from './contexts/ThemeContext';
import ModernHome from './pages/ModernHome';
import WorkshopsPage from './pages/WorkshopsPage';
import ErrorPage from './pages/ErrorPage';

function App() {
  const router = createBrowserRouter([
    {
      path: '/',
      element: <ModernHome />,
      errorElement: <ErrorPage />
    },
    {
      path: '/workshops',
      element: <WorkshopsPage />,
      errorElement: <ErrorPage />
    },
  ]);

  return (
    <ThemeProvider>
      <div className="App">
        <RouterProvider router={router} />
      </div>
    </ThemeProvider>
  );
}

export default App;
